import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "paginationWrapper d-inline-block" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a, _b;
    const _component_v_pagination = _resolveComponent("v-pagination");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_pagination, {
            modelValue: _ctx.page,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.page) = $event)),
            length: (_b = (_a = _ctx.currentPageInfo) === null || _a === void 0 ? void 0 : _a.last_page) !== null && _b !== void 0 ? _b : 1,
            "total-visible": _ctx.isMobile ? 4 : 6
        }, null, 8, ["modelValue", "length", "total-visible"])
    ]));
}
